var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bloom_header" }, [
    _c("div", { staticClass: "wrap flex_style" }, [
      _c("div", { staticClass: "header_left" }, [
        _c("img", {
          attrs: { src: require("../../assets/img/logo.png") },
          on: { click: _vm.goToHomepage }
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "ellipsis",
            staticStyle: { "max-width": "400px", width: "fit-content" },
            on: { click: _vm.toActivite }
          },
          [_vm._v(_vm._s(_vm.headerTitleInner))]
        ),
        _vm._v(" "),
        _vm.isLogin && (_vm.isSkterUser || _vm.isExperienceMode)
          ? _c(
              "div",
              {
                staticClass: "experience",
                on: { click: _vm.toggleModeDropdown }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.isExperienceMode == 1
                        ? _vm.$t("tabs.experienceMode")
                        : _vm.$t("tabs.studentMode")
                    ) +
                    "\n          "
                ),
                _vm.isSkterUser
                  ? _c("i", {
                      staticClass: "moreIcon el-input__icon",
                      class: {
                        "el-icon-arrow-down": !_vm.modeDropdownVisible,
                        "el-icon-arrow-up": _vm.modeDropdownVisible
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.modeDropdownVisible && _vm.isSkterUser
                  ? _c("div", { staticClass: "mode-dropdown" }, [
                      _c("div", { staticClass: "mode-dropdown-menu" }, [
                        _c(
                          "div",
                          {
                            staticClass: "mode-dropdown-item",
                            on: {
                              click: function($event) {
                                return _vm.handleModeChange("10")
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("tabs.studentMode")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "mode-dropdown-item",
                            on: {
                              click: function($event) {
                                return _vm.handleModeChange("90")
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("tabs.experienceMode")))]
                        )
                      ])
                    ])
                  : _vm._e()
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "nav_list" }, [
        _c(
          "button",
          {
            staticClass: "nav_ai_banxue_btn cursor",
            attrs: {
              type: "button",
              "aria-label": _vm.$t("aiStudyBuddy.title")
            },
            on: { click: _vm.openAiAssistantFromBloomHeader }
          },
          [
            _c("img", {
              attrs: {
                src: _vm.bloomHeaderAiBtnSrc,
                alt: "",
                draggable: "false"
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nav_item cursor hover",
            class: { active: +_vm.activeIndex === 1 },
            on: {
              click: function($event) {
                return _vm.handleSelect(1)
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("tabs.tasks")))]
        ),
        _vm._v(" "),
        _vm.activityId
          ? _c(
              "div",
              {
                staticClass: "nav_item cursor hover",
                class: { active: +_vm.activeIndex === 5 },
                on: {
                  click: function($event) {
                    return _vm.handleSelect(5)
                  }
                }
              },
              [_vm._v("\n          " + _vm._s(_vm.$t("tabs.Plaza")) + "\n")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nav_item cursor hover",
            class: { active: +_vm.activeIndex === 2 },
            on: { click: _vm.getTeamInfo }
          },
          [_vm._v(_vm._s(_vm.$t("flowTeamHall1")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nav_item cursor hover",
            class: { active: +_vm.activeIndex === 3 },
            on: {
              click: function($event) {
                return _vm.handleSelect(3)
              }
            }
          },
          [
            _c(
              "el-badge",
              { attrs: { value: _vm.ActNum, hidden: _vm.ActNum < 1, max: 99 } },
              [_c("span", [_vm._v(_vm._s(_vm.$t("tabs.messages")))])]
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.isLogin
          ? _c(
              "div",
              { staticClass: "user_icon" },
              [
                _c(
                  "el-popover",
                  {
                    attrs: {
                      "popper-class": "headerPopover",
                      placement: "bottom",
                      trigger: "hover"
                    },
                    on: { show: _vm.headerPopoverShow }
                  },
                  [
                    _c("div", { staticClass: "popoverCent" }, [
                      _c(
                        "div",
                        {
                          staticClass: "contentItem",
                          on: {
                            click: function($event) {
                              return _vm.handleCommand("MyActivities")
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "itemIn",
                              on: { mouseenter: _vm.contentItemMouseover }
                            },
                            [
                              _c("div"),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "itemInIcon",
                                attrs: {
                                  src:
                                    "https://img.webloom.cn/img/dropdownicon1.png",
                                  alt: ""
                                }
                              }),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "itemInIcon1",
                                attrs: {
                                  src:
                                    "https://img.webloom.cn/img/dropdownicon1act.png",
                                  alt: ""
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  class:
                                    _vm.$i18n.locale !== "zh"
                                      ? "itemInTxtEn"
                                      : "itemInTxt"
                                },
                                [_vm._v(_vm._s(_vm.$t("mine.activity")))]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "contentItem",
                          on: {
                            click: function($event) {
                              return _vm.handleCommand("MySociety")
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "itemIn" }, [
                            _c("img", {
                              staticClass: "itemInIcon",
                              attrs: {
                                src:
                                  "https://img.webloom.cn/img/dropdownicon2.png",
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "itemInIcon1",
                              attrs: {
                                src:
                                  "https://img.webloom.cn/img/dropdownicon2act.png",
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                class:
                                  _vm.$i18n.locale !== "zh"
                                    ? "itemInTxtEn"
                                    : "itemInTxt"
                              },
                              [_vm._v(_vm._s(_vm.$t("mine.society")))]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "contentItem",
                          on: {
                            click: function($event) {
                              return _vm.handleCommand("battleCenter")
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "itemIn" }, [
                            _c("img", {
                              staticClass: "itemInIcon",
                              attrs: {
                                src:
                                  "https://img.webloom.cn/img/dropdownicon3.png",
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "itemInIcon1",
                              attrs: {
                                src:
                                  "https://img.webloom.cn/img/dropdownicon3act.png",
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                class:
                                  _vm.$i18n.locale !== "zh"
                                    ? "itemInTxtEn"
                                    : "itemInTxt"
                              },
                              [_vm._v(_vm._s(_vm.$t("mine.battleCenter")))]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "contentItem",
                          on: {
                            click: function($event) {
                              return _vm.handleCommand("MyOrder")
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "itemIn" }, [
                            _c("img", {
                              staticClass: "itemInIcon",
                              attrs: {
                                src:
                                  "https://img.webloom.cn/img/dropdownicon4.png",
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "itemInIcon1",
                              attrs: {
                                src:
                                  "https://img.webloom.cn/img/dropdownicon4act.png",
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                class:
                                  _vm.$i18n.locale !== "zh"
                                    ? "itemInTxtEn"
                                    : "itemInTxt"
                              },
                              [_vm._v(_vm._s(_vm.$t("mine.orders")))]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "contentItem",
                          on: {
                            click: function($event) {
                              return _vm.handleCommand("MessageUs")
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "itemIn" }, [
                            _c("img", {
                              staticClass: "itemInIcon",
                              attrs: {
                                src: "https://img.webloom.cn/Img/gondan0.png",
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "itemInIcon1",
                              attrs: {
                                src: "https://img.webloom.cn/Img/gondan1.png",
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                class:
                                  _vm.$i18n.locale !== "zh"
                                    ? "itemInTxtEn"
                                    : "itemInTxt"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.$t("mine.messageUs")) +
                                    "\n                    "
                                ),
                                _vm.TicketNum > 0
                                  ? _c("div", { staticClass: "TicketNum" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.TicketNum > 99
                                            ? "99+"
                                            : _vm.TicketNum
                                        )
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "contentItem",
                          on: {
                            click: function($event) {
                              return _vm.handleCommand("setting")
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "itemIn" }, [
                            _c("img", {
                              staticClass: "itemInIcon",
                              attrs: {
                                src:
                                  "https://img.webloom.cn/img/dropdownicon5.png",
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "itemInIcon1",
                              attrs: {
                                src:
                                  "https://img.webloom.cn/img/dropdownicon5act.png",
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                class:
                                  _vm.$i18n.locale !== "zh"
                                    ? "itemInTxtEn"
                                    : "itemInTxt"
                              },
                              [_vm._v(_vm._s(_vm.$t("mine.setting")))]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "contentItem exitBox",
                          on: {
                            click: function($event) {
                              return _vm.handleCommand("logout")
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "itemIn" }, [
                            _c("img", {
                              staticClass: "itemInIcon",
                              attrs: {
                                src:
                                  "https://img.webloom.cn/img/dropdownicon6.png",
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "itemInIcon1",
                              attrs: {
                                src:
                                  "https://img.webloom.cn/img/dropdownicon6act.png",
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                class:
                                  _vm.$i18n.locale !== "zh"
                                    ? "itemInTxtEn exit"
                                    : "itemInTxt exit"
                              },
                              [_vm._v(_vm._s(_vm.$t("mine.quite")))]
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "img_container",
                        attrs: { slot: "reference" },
                        on: { click: _vm.checkStatu },
                        slot: "reference"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: _vm.hearderImg,
                            onerror:
                              "this.src='//img.webloom.cn/img/logo/default-user.png';this.onerror=null"
                          }
                        })
                      ]
                    )
                  ]
                )
              ],
              1
            )
          : _c(
              "div",
              { staticClass: "user_login", on: { click: _vm.handleLogin } },
              [_vm._v(_vm._s(_vm.$t("tabs.loginOrRes")))]
            )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "change-lang cursor", on: { click: _vm.changeLang } },
      [
        _c("span", { class: { active: _vm.$i18n.locale == "en" } }, [
          _vm._v("EN")
        ]),
        _vm._v("/"),
        _c("span", { class: { active: _vm.$i18n.locale != "en" } }, [
          _vm._v("中")
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-605d4b93", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-605d4b93","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/public/header.vue
// module id = null
// module chunks = 